import(/* webpackMode: "eager" */ "/vercel/path0/apps/wallet-dashboard/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Amplitude"] */ "/vercel/path0/apps/wallet-dashboard/components/Amplitude.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/wallet-dashboard/components/connection-guard/ConnectionGuard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/wallet-dashboard/providers/AppProviders.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.23_@babel+core@7.25.2_@playwright+test@1.47.2_babel-plugin-macros@3.1.0_react-dom@1_ruzgkzoufbavgpif3mas67kn6a/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/sdk/dapp-kit/dist/esm/index.css");
